import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ffc53wbmve: FaireBrandEntity = {
  token: "b_ffc53wbmve",
  type: "brand",
  name: "Chubby Lamb",
  avatarUrl:
    "https://cdn.faire.com/fastly/bf54b393d2694fcd11884a1d4e04b64a50cee36a531d0488a6bb728130c10080.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6066e5bdae98555f2fb77752a8315ab62dee692a7a383919fb75fe3b09310846.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bf54b393d2694fcd11884a1d4e04b64a50cee36a531d0488a6bb728130c10080.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6066e5bdae98555f2fb77752a8315ab62dee692a7a383919fb75fe3b09310846.jpeg",
  location: "Lake Saint Louis , MO, USA",
  minimumOrderDollars: 250,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "As seen in British Vogue's Baby & Child & Yummy Mummy Magazine- \nChubby Lamb offers a growing selection of high-quality organic cotton wear essentials for babies & toddlers. Our collections are thoughtfully curated with the utmost attention to detail. All of our garments are made from GOTS certified organic cotton, ensuring little ones delicate skin is protected from harmful chemicals and toxins commonly found in conventional fabrics. Modern cut pieces, available in timeless neutral colors, that are designed to provide functionality while focussing on the simplicity of baby-hood.\nWe look forward to having Chubby Lamb be a part of your coziest moments, as we deliver affordable cotton wear styles that meet parents expectations and exceed baby & toddler comfort needs.\n\nThank you for considering my small business as I look forward to the opportunity of growing together. If the quantity of your desired pieces are not available or you have any additional questions, please feel free to reach out via email:  [redacted-email]\n-Desirae\nKnox's Mom",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:53.082Z",
    importedBy: "entity-db-cli",
  },
};
